module.exports = __webpack_public_path__ + "img/icons-fill-timesheets.6d2f5879.svg";